/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Doc_Type_Ownership_HistoryInputs */

const en_doc_type_ownership_history = /** @type {(inputs: Doc_Type_Ownership_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ownership History`)
};

const id_doc_type_ownership_history = /** @type {(inputs: Doc_Type_Ownership_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riwayat Kepemilikan`)
};

/** @type {(inputs: Doc_Type_Ownership_HistoryInputs) => LocalizedString} */
const es_doc_type_ownership_history = en_doc_type_ownership_history;

/** @type {(inputs: Doc_Type_Ownership_HistoryInputs) => LocalizedString} */
const fr_doc_type_ownership_history = en_doc_type_ownership_history;

/** @type {(inputs: Doc_Type_Ownership_HistoryInputs) => LocalizedString} */
const de_doc_type_ownership_history = en_doc_type_ownership_history;

/** @type {(inputs: Doc_Type_Ownership_HistoryInputs) => LocalizedString} */
const ja_doc_type_ownership_history = en_doc_type_ownership_history;

/** @type {(inputs: Doc_Type_Ownership_HistoryInputs) => LocalizedString} */
const zh_doc_type_ownership_history = en_doc_type_ownership_history;

/** @type {(inputs: Doc_Type_Ownership_HistoryInputs) => LocalizedString} */
const ar_doc_type_ownership_history = en_doc_type_ownership_history;

/** @type {(inputs: Doc_Type_Ownership_HistoryInputs) => LocalizedString} */
const it_doc_type_ownership_history = en_doc_type_ownership_history;

/** @type {(inputs: Doc_Type_Ownership_HistoryInputs) => LocalizedString} */
const ru_doc_type_ownership_history = en_doc_type_ownership_history;

/** @type {(inputs: Doc_Type_Ownership_HistoryInputs) => LocalizedString} */
const pt_doc_type_ownership_history = en_doc_type_ownership_history;

/** @type {(inputs: Doc_Type_Ownership_HistoryInputs) => LocalizedString} */
const ko_doc_type_ownership_history = en_doc_type_ownership_history;

/**
* | output |
* | --- |
* | "Ownership History" |
*
* @param {Doc_Type_Ownership_HistoryInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const doc_type_ownership_history = /** @type {((inputs?: Doc_Type_Ownership_HistoryInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Type_Ownership_HistoryInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_type_ownership_history(inputs)
	if (locale === "es") return es_doc_type_ownership_history(inputs)
	if (locale === "fr") return fr_doc_type_ownership_history(inputs)
	if (locale === "de") return de_doc_type_ownership_history(inputs)
	if (locale === "ja") return ja_doc_type_ownership_history(inputs)
	if (locale === "zh") return zh_doc_type_ownership_history(inputs)
	if (locale === "ar") return ar_doc_type_ownership_history(inputs)
	if (locale === "id") return id_doc_type_ownership_history(inputs)
	if (locale === "it") return it_doc_type_ownership_history(inputs)
	if (locale === "ru") return ru_doc_type_ownership_history(inputs)
	if (locale === "pt") return pt_doc_type_ownership_history(inputs)
	return ko_doc_type_ownership_history(inputs)
});